module.exports = __webpack_public_path__ + "img/prezent.cbf3f445.png";